import { type UseQueryResult, useQuery } from 'react-query';
import { VendorUserService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetVendorUserOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const vendorDesignationServiceOptions = useQuery(
    ['getVendorDesignationUserServiceOptions'],
    async () => {
      return await handleRequest(VendorUserService.getApiCustomerApiAppVendorUserVendorUser());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: `${item.firstName ?? ''} ${item.middleName ?? ''} ${item.lastName ?? ''}`,
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return vendorDesignationServiceOptions;
};

export default useGetVendorUserOptions;
